import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

const GuidedTour = ({ isOpen, onClose, steps, currentStep, onNext, onPrev, moodColor }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  
  const step = steps[currentStep];
  const isLast = currentStep === steps.length - 1;
  const isFirst = currentStep === 0;

  return (
    <div className="tour-overlay" onClick={onClose}>
      <motion.div 
        className="tour-modal"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        onClick={e => e.stopPropagation()}
      >
        <div className="tour-header">
          <span className="tour-step-indicator">{currentStep + 1} / {steps.length}</span>
          <button onClick={onClose} className="tour-close"><X size={18} /></button>
        </div>
        <h3 className="tour-title" style={{ color: moodColor }}>{t(step.titleKey)}</h3>
        <p className="tour-content">{t(step.contentKey)}</p>
        <div className="tour-footer">
          <button 
            onClick={onPrev} 
            disabled={isFirst}
            className="tour-btn tour-btn-secondary"
          >
            {t('previous')}
          </button>
          <button 
            onClick={isLast ? onClose : onNext}
            className="tour-btn tour-btn-primary"
            style={{ background: moodColor }}
          >
            {isLast ? t('finish') : t('next')}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

// Tour steps configuration
const TOUR_STEPS = [
  { target: 'mood-orb', titleKey: 'tourTitle1', contentKey: 'tourContent1' },
  { target: 'mood-adjective', titleKey: 'tourTitle2', contentKey: 'tourContent2' },
  { target: 'regional-panel', titleKey: 'tourTitle3', contentKey: 'tourContent3' },
  { target: 'word-cloud-panel', titleKey: 'tourTitle4', contentKey: 'tourContent4' },
  { target: 'history-panel', titleKey: 'tourTitle5', contentKey: 'tourContent5' },
];

export { GuidedTour, TOUR_STEPS };
